export default __webpack_public_path__ + "static/media/svg-2.2f50e135.svg";